import { IReviews } from "../Interfaces/constants";

export const reviews: IReviews[] = [
  {
    name: 'Armen Sargsyan',
    comment: "I just wanted to take the time to say how efficient and helpful everyone at Mavsign is. I was apprehensive when we were told to use this service but you have proved to me time and time again how great it is to have someone to cover the dealership with a professional notary service and people who genuinely care.",
    stars: 5,
  },
  {
    name: 'Freemont BMW',
    comment: "Peace of Mind! Cheap insurance.",
    stars: 5
  },
  {
    name: 'Henderson BMW',
    comment: "Made the offsite process much easier and relieved the concern of any fraudulent activity.",
    stars: 5
  },
  {
    name: 'South Bay Toyota',
    comment: "What Mavsign means to us is security. This service offers peace of mind knowing that our documents and customers are being handled by professionals. As you know, identity theft is very real and by using your service it significantly reduces that threat!",
    stars: 5
  },
  {
    name: 'Fletcher Jones Imports',
    comment: "I just wanted to take the time to say how efficient and helpful everyone at Mavsign is. I was apprehensive when we were told to use this service but you have proved to me time and time again how it is to have someone to cover the dealership with a professional notary service and people who genuinely care.",
    stars: 5
  },
  {
    name: 'Mercedes Benz of Tampa',
    comment: "Mavsign has changed the way we do business on the internet. It enables us to sell more cars and finance people thus creating more profit!",
    stars: 5
  },
  {
    name: 'Dessert Honda',
    comment: "If you aren't using Mavsign for your out-of-state or out-of-store signings you're just not thinking clearly. I highly recommend you call the folks at Mavsign so they can eliminate your risk like they did with my dealership.",
    stars: 5
  },
  {
    name: 'South Bay Jaguar',
    comment: "Peace of mind! Easy to use! Builds confidence!",
    stars: 5
  },
  {
    name: 'Land Rover Encino',
    comment: "Easy to use! They understand car people!",
    stars: 5
  },
];